import React, { useState } from 'react'
import CommonModal from 'jbc-front/components/CommonModal';
import Button from 'jbc-front/components/Button';
import { useTranslation } from 'react-i18next'
import { useTutorialContext } from '../TutorialProvider';

export default function NextStep2Modal() {
  const { t } = useTranslation()
  const { setTutorialStep2 } = useTutorialContext()
  const [onOpenModal, setOnOpenModal] = useState(true)
  const setOnCloseModal = () => setOnOpenModal(false)

  const onNextStep = () => {
    setOnCloseModal()
    setTutorialStep2({ run: true, stepIndex: 0, tourCompleted: false, type: 'create' })
  }

  return (
    <CommonModal hideModal={setOnCloseModal} isOpen={onOpenModal} ariaHideApp={false}>
      <CommonModal.Header hideModal={setOnCloseModal}>{t('features.GuideTour.Modal.Title')}</CommonModal.Header>
      <CommonModal.Body>{t('features.GuideTour.Modal.StartNextTutorial')} </CommonModal.Body>
      <CommonModal.Footer>
        <CommonModal.Buttons>
          <Button onClick={setOnCloseModal}>{t('features.GuideTour.Button.close')}</Button>
          <Button primary onClick={onNextStep}>{t('features.GuideTour.Button.next')}</Button>
        </CommonModal.Buttons>
      </CommonModal.Footer>
    </CommonModal>
  )
}